// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"97c8f9de","796":"fd069e86"}[chunkId] + ".chunk.js";
};